module.exports = __webpack_public_path__ + "img/test2.a7b2d3f9.png";